"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configurator = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var queryString = require("query-string");
var translations_1 = require("@hip/translations");
var interfaces_1 = require("@hip/interfaces");
var kf_js_communicator_1 = require("@mxt/kf-js-communicator");
var util_sagas_1 = require("@hip/util-sagas");
var halcyon_components_react_1 = require("@realm-kf/halcyon-components-react");
var components_1 = require("../components");
var footer_1 = require("../components/footer");
var header_1 = require("../components/header");
var confirm_action_1 = require("../components/modals/confirm-action");
var communicator_1 = require("../core/communicator");
var utils_1 = require("../core/utils");
var marxent_1 = require("../core/marxent");
var actions_1 = require("../core/modals/actions");
var reducer_1 = require("../core/modals/reducer");
var configurator_module_css_1 = __importDefault(require("./configurator.module.css"));
var getMxtUrl = function (parsedQueryStringKeys, mxtUrls) {
    // ToDo: Refactor in scope of HIP-5191
    if (parsedQueryStringKeys.find(function (key) { return key === 'atomia'; }))
        return mxtUrls.atomia;
    if (parsedQueryStringKeys.find(function (key) { return key === 'fireplaces'; }))
        return mxtUrls.fireplaces;
    if (parsedQueryStringKeys.find(function (key) { return key === 'alara'; }))
        return mxtUrls.alara;
    return mxtUrls.atomia;
};
var Configurator = function () {
    var dispatch = react_redux_1.useDispatch();
    var mxt = react_1.default.useMemo(function () { return new kf_js_communicator_1.JsCommunicator(); }, []);
    var mxtContainerRef = react_1.default.useRef();
    var mxtUrls = react_redux_1.useSelector(utils_1.getMxtAppUrls);
    var _a = react_1.useState(null), mxtUrl = _a[0], setMxtUrl = _a[1];
    var isDirty = react_redux_1.useSelector(communicator_1.getIsDirty);
    var exitHandler = function () {
        var dispatchExit = function () {
            dispatch(communicator_1.actions.exit());
        };
        isDirty
            ? dispatch(util_sagas_1.requireConfirmationActions.init({
                onStart: function () {
                    return dispatch(actions_1.actions.open({ modal: reducer_1.MODALS.CONFIRM_ACTION }));
                },
                onEnd: function () {
                    return dispatch(actions_1.actions.close({ modal: reducer_1.MODALS.CONFIRM_ACTION }));
                },
                onConfirm: dispatchExit,
            }))
            : dispatchExit();
    };
    var homeHandler = function () {
        var dispatchHome = function () {
            dispatch(communicator_1.actions.home());
        };
        isDirty
            ? dispatch(util_sagas_1.requireConfirmationActions.init({
                onStart: function () {
                    return dispatch(actions_1.actions.open({ modal: reducer_1.MODALS.CONFIRM_ACTION }));
                },
                onEnd: function () {
                    return dispatch(actions_1.actions.close({ modal: reducer_1.MODALS.CONFIRM_ACTION }));
                },
                onConfirm: dispatchHome,
            }))
            : dispatchHome();
    };
    react_1.default.useEffect(function () {
        if (mxtUrls) {
            var parsedQuery = queryString.parse(location.search);
            setMxtUrl(getMxtUrl(Object.keys(parsedQuery), mxtUrls));
        }
    }, [mxtUrls]);
    react_1.default.useEffect(function () {
        dispatch(marxent_1.actions.mxtInit(mxt));
        dispatch(utils_1.actions.init());
    }, []);
    react_1.default.useEffect(function () {
        if (mxtUrl) {
            mxt.initWithoutToken(mxtUrl, undefined, mxtContainerRef.current);
            var iframeEventHandler_1 = mxt.subscribeToIFrame(function (mxtEvent) {
                return dispatch(marxent_1.actions.mxtEvent({ mxtEvent: mxtEvent }));
            });
            return function () { return mxt.clearPostMessageSubscription(iframeEventHandler_1); };
        }
    }, [mxtUrl]);
    return mxtUrl ? (react_1.default.createElement("div", { className: configurator_module_css_1.default.ConfiguratorLayout },
        react_1.default.createElement(header_1.Header, { opco: interfaces_1.OPCOS.BQUK, onExit: exitHandler, onHome: homeHandler }),
        react_1.default.createElement(components_1.MarxentApp, { ref: mxtContainerRef }),
        react_1.default.createElement(footer_1.Footer, null),
        react_1.default.createElement(confirm_action_1.ConfirmActionModal, { modalTitle: translations_1._t('configurator.confirm-action-modal.header') },
            react_1.default.createElement(halcyon_components_react_1.Text, null, translations_1._t('configurator.confirm-action-modal.message'))))) : (react_1.default.createElement("div", null, "Loading..."));
};
exports.Configurator = Configurator;
